var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.pack.packName.toLowerCase()))]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v("("+_vm._s(_vm.pack.value)+" "+_vm._s(_vm.pack.unitName.toLowerCase())+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }